import { useTheme } from "@/utils/theme-context";
import Button from "./UI/Button";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoaderProduct from "./UI/QuestionaryLoader";

const Questionary = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);

  const [selectedCountries, setSelectedCountries] = useState(["США"]);
  const [selectedCategories, setSelectedCategories] = useState(["Все товары"]);

  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const isFormFilled = localStorage.getItem("isQuestionaryFilled");
    if (isFormFilled) {
      navigate("/course/amazon/products-list");
    }
  }, [navigate]);

  const handleSave = (e) => {
    e.preventDefault();

    setLoading(true);

    localStorage.setItem("isQuestionaryFilled", "true");

    setTimeout(() => {
      setLoading(false);
      navigate("/course/amazon/products-list");
    }, 4000);

    setErrorMessage("");
  };

  const countriesList = ["США", "ОАЭ", "Европа", "Япония", "Все страны"];

  const categories = [
    "Все товары",
    "Бьюти",
    "Безопасность",
    "Уход за волосами",
    "Товары для спорта",
    "Для питомцев",
    "Для фото / видео",
    "Для офиса",
    "Для дома",
    "Аксессуары для телефонов",
    "Аксессуары для ноутбуков",
    "Свой товар",
  ];

  // const budgets = ["100$", "200$", "300$", "500$", "1000$", "2000$"];

  const handleToggle = (item, selectedItems, setSelectedItems) => {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(item)
        ? prevSelected.filter((i) => i !== item)
        : [...prevSelected, item],
    );
  };

  if (loading) {
    return <LoaderProduct />;
  }

  return (
    <div className={`layout layout--${theme}`}>
      <div className="accountInfo">
        <form className="accountInfo-body">
          <p className="layout__title questionary__title">
            Заполните анкету и подберем товар
          </p>
          <div className="accountInfo-body-item">
            <label className="input input--white" htmlFor="country">
              В какой стране хотите продавать?
            </label>
            <div className="checkbox-group">
              {countriesList.map((country) => (
                <button
                  key={country}
                  className={`tag-button ${
                    selectedCountries.includes(country) ? "selected" : ""
                  }`}
                  onClick={() =>
                    handleToggle(
                      country,
                      selectedCountries,
                      setSelectedCountries,
                    )
                  }
                  type="button"
                >
                  {country}
                </button>
              ))}
            </div>
          </div>

          {/* <div className="accountInfo-body-item">
            <label className="input input--white" htmlFor="country">
              Ваш бюджет на закупку
            </label>
            <div className="checkbox-group">
              {budgets.map((budget) => (
                <button
                  key={budget}
                  className={`tag-button ${
                    selectedBudget.includes(budget) ? "selected" : ""
                  }`}
                  onClick={() =>
                    handleToggle(budget, selectedBudget, setBudget)
                  }
                  type="button"
                >
                  {budget}
                </button>
              ))}
            </div>
          </div> */}

          <div className="accountInfo-body-item">
            <label className="input input--white" htmlFor="country">
              Выберите категорию товаров
            </label>
            <div className="checkbox-group">
              {categories.map((category) => (
                <button
                  key={category}
                  className={`tag-button ${
                    selectedCategories.includes(category) ? "selected" : ""
                  }`}
                  onClick={() =>
                    handleToggle(
                      category,
                      selectedCategories,
                      setSelectedCategories,
                    )
                  }
                  type="button"
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {errorMessage && (
            <p className="authentication-box__error "> {errorMessage} </p>
          )}

          <Button
            disabled={loading}
            title="Забрать товары"
            color="pink"
            onClick={handleSave}
          />
        </form>
      </div>
    </div>
  );
};

export default Questionary;
